import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getLastResults, getDetailResults } from "../../../apiservices/CasionApi";
import RefResultModal from "../../casinoComponents/refResultModal";
import FiveCricketResultBody from "../../casinoComponents/refResultModal/FiveCricketResultBody";
import { formatRefMatchTime } from "../../../utils/refMatchTime";

/**
 * Last Result items of the five-cricket pages (reference LastResultsSection):
 * win 1 -> span.resulta, 2 -> span.resultb, 0 -> span.resulttie, with the per-game letters.
 * Click: page loader overlay while the round detail loads, then the reference result modal.
 */
export default function FiveCricketLastResults({ gameType, labels, roundId }) {
  const [lastResults, setLastResults] = useState([]);
  const [detail, setDetail] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // Reference reloads the list when the round changes
  useEffect(() => {
    let alive = true;
    getLastResults(gameType)
      .then((response) => {
        if (alive && Array.isArray(response?.data?.data?.res)) setLastResults(response.data.data.res);
      })
      .catch((error) => console.error("Error fetching last results:", error));
    return () => {
      alive = false;
    };
  }, [gameType, roundId]);

  const handleClick = async (mid) => {
    if (loading || !mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(gameType, String(mid));
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetail(t1);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching detail results:", error);
    }
    setLoading(false);
  };

  return (
    <>
      {lastResults.map((r, i) => {
        const win = String(r.win);
        const cls = win === "1" ? "resulta" : win === "2" ? "resultb" : win === "0" ? "resulttie" : undefined;
        return (
          <span key={`${r.mid}-${i}`} className={cls} onClick={() => handleClick(r.mid)}>
            {win === "1" ? labels[0] : null} {win === "2" ? labels[1] : null} {win === "0" ? "T" : null}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector(".page-content") || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detail}
        onHide={() => {
          setShowModal(false);
          setDetail(null);
        }}
        title={`${detail?.ename || ""} Result`}
        roundId={detail?.rid}
        matchTime={formatRefMatchTime(detail?.mtime)}
      >
        <FiveCricketResultBody t1={detail} />
      </RefResultModal>
    </>
  );
}
